/**
 * Константи для телефонних кодів країн
 */

export interface PhoneCode {
  isoCode: string // ISO 3166-1 alpha-2 код страны (двухбуквенный)
  phoneCode: string // Повний міжнародний код набору (напр. 1684 для American Samoa)
  label: string
  areaCodes?: string[] // Масив area codes (для +1 — Канада, США, тощо)
  /** Фіксована довжина: totalLength. Для діапазону довжин — minLength/maxLength (напр. Vatican 6–7) */
  minLength?: number // Мінімальна довжина номера після коду (тільки якщо є діапазон)
  maxLength?: number // Максимальна довжина номера після коду (тільки якщо є діапазон)
  totalLength?: number // Загальна довжина цифр з кодом без + (для фіксованої довжини)
  nextDigitPattern?: string[] // Паттерн наступної цифри після коду (напр. KZ/RU для +7)
}

export const PhoneCodes: PhoneCode[] = [
  { isoCode: 'UA', phoneCode: '380', label: 'Country:Ukraine', totalLength: 12 },
  { isoCode: 'AU', phoneCode: '61', label: 'Country:Australia', totalLength: 11 },
  { isoCode: 'AT', phoneCode: '43', label: 'Country:Austria' },
  { isoCode: 'AZ', phoneCode: '994', label: 'Country:Azerbaijan' },
  { isoCode: 'AX', phoneCode: '35818', label: 'Country:Aland Islands' },
  { isoCode: 'AL', phoneCode: '355', label: 'Country:Albania' },
  { isoCode: 'DZ', phoneCode: '213', label: 'Country:Algeria' },
  { isoCode: 'AS', phoneCode: '1684', label: 'Country:American Samoa', totalLength: 11 },
  { isoCode: 'AI', phoneCode: '1264', label: 'Country:Anguilla', totalLength: 11 },
  { isoCode: 'AO', phoneCode: '244', label: 'Country:Angola', totalLength: 12 },
  { isoCode: 'AD', phoneCode: '376', label: 'Country:Andorra' },
  { isoCode: 'AG', phoneCode: '1268', label: 'Country:Antigua and Barbuda', totalLength: 11 },
  { isoCode: 'AR', phoneCode: '54', label: 'Country:Argentina', totalLength: 12 },
  { isoCode: 'AM', phoneCode: '374', label: 'Country:Armenia', totalLength: 11 },
  { isoCode: 'AW', phoneCode: '297', label: 'Country:Aruba' },
  { isoCode: 'AF', phoneCode: '93', label: 'Country:Afghanistan', totalLength: 11 },
  { isoCode: 'BS', phoneCode: '1242', label: 'Country:Bahamas', totalLength: 11 },
  { isoCode: 'BD', phoneCode: '880', label: 'Country:Bangladesh' },
  { isoCode: 'BB', phoneCode: '1246', label: 'Country:Barbados', totalLength: 11 },
  { isoCode: 'BH', phoneCode: '973', label: 'Country:Bahrain' },
  { isoCode: 'BY', phoneCode: '375', label: 'Country:Belarus' },
  { isoCode: 'BZ', phoneCode: '501', label: 'Country:Belize' },
  { isoCode: 'BE', phoneCode: '32', label: 'Country:Belgium' },
  { isoCode: 'BJ', phoneCode: '229', label: 'Country:Benin', totalLength: 11 },
  { isoCode: 'BM', phoneCode: '1441', label: 'Country:Bermuda', totalLength: 11 },
  { isoCode: 'BG', phoneCode: '359', label: 'Country:Bulgaria' },
  { isoCode: 'BO', phoneCode: '591', label: 'Country:Bolivia', totalLength: 11 },
  { isoCode: 'BQ', phoneCode: '5997', label: 'Country:Bonaire, Sint Eustatius and Saba' },
  { isoCode: 'BA', phoneCode: '387', label: 'Country:Bosnia and Herzegovina', totalLength: 11 },
  { isoCode: 'BW', phoneCode: '267', label: 'Country:Botswana' },
  { isoCode: 'BR', phoneCode: '55', label: 'Country:Brazil', totalLength: 12 },
  { isoCode: 'IO', phoneCode: '246', label: 'Country:British Indian Ocean Territory' },
  { isoCode: 'BN', phoneCode: '673', label: 'Country:Brunei' },
  { isoCode: 'BF', phoneCode: '226', label: 'Country:Burkina Faso', totalLength: 11 },
  { isoCode: 'BI', phoneCode: '257', label: 'Country:Burundi', totalLength: 11 },
  { isoCode: 'BT', phoneCode: '975', label: 'Country:Bhutan' },
  { isoCode: 'VU', phoneCode: '678', label: 'Country:Vanuatu' },
  { isoCode: 'VA', phoneCode: '39', label: 'Country:Vatican', minLength: 6, maxLength: 7 },
  { isoCode: 'GB', phoneCode: '44', label: 'Country:United Kingdom' },
  { isoCode: 'HU', phoneCode: '36', label: 'Country:Hungary' },
  { isoCode: 'VE', phoneCode: '58', label: 'Country:Venezuela', totalLength: 12 },
  { isoCode: 'VG', phoneCode: '1284', label: 'Country:British Virgin Islands', totalLength: 11 },
  { isoCode: 'VI', phoneCode: '1340', label: 'Country:US Virgin Islands', totalLength: 11 },
  { isoCode: 'TL', phoneCode: '670', label: 'Country:East Timor' },
  { isoCode: 'VN', phoneCode: '84', label: 'Country:Vietnam' },
  { isoCode: 'GA', phoneCode: '241', label: 'Country:Gabon' },
  { isoCode: 'HT', phoneCode: '509', label: 'Country:Haiti', totalLength: 11 },
  { isoCode: 'GY', phoneCode: '592', label: 'Country:Guyana' },
  { isoCode: 'GM', phoneCode: '220', label: 'Country:Gambia' },
  { isoCode: 'GH', phoneCode: '233', label: 'Country:Ghana' },
  { isoCode: 'GP', phoneCode: '590590', label: 'Country:Guadeloupe', totalLength: 12 },
  { isoCode: 'GT', phoneCode: '502', label: 'Country:Guatemala', totalLength: 11 },
  { isoCode: 'GN', phoneCode: '224', label: 'Country:Guinea', totalLength: 11 },
  { isoCode: 'GW', phoneCode: '245', label: 'Country:Guinea-Bissau' },
  { isoCode: 'DE', phoneCode: '49', label: 'Country:Germany' },
  { isoCode: 'GG', phoneCode: '441481', label: 'Country:Guernsey' },
  { isoCode: 'GI', phoneCode: '350', label: 'Country:Gibraltar' },
  { isoCode: 'HN', phoneCode: '504', label: 'Country:Honduras', totalLength: 11 },
  { isoCode: 'HK', phoneCode: '852', label: 'Country:Hong Kong' },
  { isoCode: 'GD', phoneCode: '1473', label: 'Country:Grenada', totalLength: 11 },
  { isoCode: 'GL', phoneCode: '299', label: 'Country:Greenland' },
  { isoCode: 'GR', phoneCode: '30', label: 'Country:Greece', totalLength: 12 },
  { isoCode: 'GE', phoneCode: '995', label: 'Country:Georgia', totalLength: 12 },
  { isoCode: 'GU', phoneCode: '1671', label: 'Country:Guam', totalLength: 11 },
  { isoCode: 'DK', phoneCode: '45', label: 'Country:Denmark', totalLength: 10 },
  { isoCode: 'JE', phoneCode: '441534', label: 'Country:Jersey' },
  { isoCode: 'DJ', phoneCode: '253', label: 'Country:Djibouti' },
  { isoCode: 'DM', phoneCode: '1767', label: 'Country:Dominica', totalLength: 11 },
  { isoCode: 'DO', phoneCode: '1', label: 'Country:Dominican Republic', areaCodes: ['809', '829', '849'], totalLength: 11 },
  { isoCode: 'EG', phoneCode: '20', label: 'Country:Egypt' },
  { isoCode: 'ZM', phoneCode: '260', label: 'Country:Zambia', totalLength: 12 },
  { isoCode: 'ZW', phoneCode: '263', label: 'Country:Zimbabwe' },
  { isoCode: 'IL', phoneCode: '972', label: 'Country:Israel' },
  { isoCode: 'IN', phoneCode: '91', label: 'Country:India' },
  { isoCode: 'ID', phoneCode: '62', label: 'Country:Indonesia' },
  { isoCode: 'IQ', phoneCode: '964', label: 'Country:Iraq' },
  { isoCode: 'IR', phoneCode: '98', label: 'Country:Iran' },
  { isoCode: 'IE', phoneCode: '353', label: 'Country:Ireland' },
  { isoCode: 'IS', phoneCode: '354', label: 'Country:Iceland' },
  { isoCode: 'ES', phoneCode: '34', label: 'Country:Spain', totalLength: 11 },
  { isoCode: 'IT', phoneCode: '39', label: 'Country:Italy', totalLength: 11 },
  { isoCode: 'YE', phoneCode: '967', label: 'Country:Yemen' },
  { isoCode: 'CV', phoneCode: '238', label: 'Country:Cape Verde' },
  { isoCode: 'KZ', phoneCode: '7', label: 'Country:Kazakhstan', totalLength: 11, nextDigitPattern: ['6', '7'] },
  { isoCode: 'KY', phoneCode: '1345', label: 'Country:Cayman Islands', totalLength: 11 },
  { isoCode: 'KH', phoneCode: '855', label: 'Country:Cambodia', totalLength: 11 },
  { isoCode: 'CM', phoneCode: '237', label: 'Country:Cameroon', totalLength: 11 },
  {
    isoCode: 'CA',
    phoneCode: '1',
    label: 'Country:Canada',
    totalLength: 11,
    areaCodes: [
      '204', '226', '236', '249', '250', '289', '306', '343', '365', '403',
      '416', '418', '431', '437', '438', '450', '506', '514', '519', '548',
      '579', '581', '587', '604', '613', '639', '647', '672', '705', '709',
      '742', '753', '778', '780', '782', '807', '819', '825', '867', '873',
      '902', '905', '942',
    ],
  },
  { isoCode: 'QA', phoneCode: '974', label: 'Country:Qatar' },
  { isoCode: 'KE', phoneCode: '254', label: 'Country:Kenya' },
  { isoCode: 'CY', phoneCode: '357', label: 'Country:Cyprus' },
  { isoCode: 'KG', phoneCode: '996', label: 'Country:Kyrgyzstan', totalLength: 12 },
  { isoCode: 'KI', phoneCode: '686', label: 'Country:Kiribati' },
  { isoCode: 'CN', phoneCode: '86', label: 'Country:China' },
  { isoCode: 'CC', phoneCode: '6191', label: 'Country:Cocos Islands', minLength: 4, maxLength: 5, totalLength: 9 },
  { isoCode: 'CO', phoneCode: '57', label: 'Country:Colombia' },
  { isoCode: 'KM', phoneCode: '269', label: 'Country:Comoros' },
  { isoCode: 'CG', phoneCode: '242', label: 'Country:Congo' },
  { isoCode: 'CD', phoneCode: '243', label: 'Country:Congo, Democratic Republic' },
  { isoCode: 'KP', phoneCode: '850', label: 'Country:Korea, North' },
  { isoCode: 'KR', phoneCode: '82', label: 'Country:Korea, South' },
  { isoCode: 'CR', phoneCode: '506', label: 'Country:Costa Rica', totalLength: 11 },
  { isoCode: 'CI', phoneCode: '225', label: 'Country:Cote d\'Ivoire', totalLength: 11 },
  { isoCode: 'CU', phoneCode: '53', label: 'Country:Cuba' },
  { isoCode: 'KW', phoneCode: '965', label: 'Country:Kuwait' },
  { isoCode: 'CW', phoneCode: '5999', label: 'Country:Curacao' },
  { isoCode: 'LA', phoneCode: '856', label: 'Country:Laos' },
  { isoCode: 'LV', phoneCode: '371', label: 'Country:Latvia' },
  { isoCode: 'LS', phoneCode: '266', label: 'Country:Lesotho', totalLength: 11 },
  { isoCode: 'LR', phoneCode: '231', label: 'Country:Liberia' },
  { isoCode: 'LB', phoneCode: '961', label: 'Country:Lebanon' },
  { isoCode: 'LY', phoneCode: '218', label: 'Country:Libya' },
  { isoCode: 'LT', phoneCode: '370', label: 'Country:Lithuania', totalLength: 11 },
  { isoCode: 'LI', phoneCode: '423', label: 'Country:Liechtenstein' },
  { isoCode: 'LU', phoneCode: '352', label: 'Country:Luxembourg' },
  { isoCode: 'MU', phoneCode: '230', label: 'Country:Mauritius' },
  { isoCode: 'MR', phoneCode: '222', label: 'Country:Mauritania' },
  { isoCode: 'MG', phoneCode: '261', label: 'Country:Madagascar' },
  { isoCode: 'YT', phoneCode: '262269', label: 'Country:Mayotte', totalLength: 12 },
  { isoCode: 'MO', phoneCode: '853', label: 'Country:Macau' },
  { isoCode: 'MK', phoneCode: '389', label: 'Country:Macedonia' },
  { isoCode: 'MW', phoneCode: '265', label: 'Country:Malawi' },
  { isoCode: 'MY', phoneCode: '60', label: 'Country:Malaysia' },
  { isoCode: 'ML', phoneCode: '466', label: 'Country:Mali', totalLength: 11 },
  { isoCode: 'MV', phoneCode: '960', label: 'Country:Maldives' },
  { isoCode: 'MT', phoneCode: '356', label: 'Country:Malta' },
  { isoCode: 'MA', phoneCode: '212', label: 'Country:Morocco', totalLength: 12 },
  { isoCode: 'MQ', phoneCode: '596', label: 'Country:Martinique' },
  { isoCode: 'MH', phoneCode: '692', label: 'Country:Marshall Islands' },
  { isoCode: 'MX', phoneCode: '52', label: 'Country:Mexico', totalLength: 12 },
  { isoCode: 'FM', phoneCode: '691', label: 'Country:Micronesia' },
  { isoCode: 'MZ', phoneCode: '258', label: 'Country:Mozambique' },
  { isoCode: 'MD', phoneCode: '373', label: 'Country:Moldova', totalLength: 11 },
  { isoCode: 'MC', phoneCode: '377', label: 'Country:Monaco' },
  { isoCode: 'MN', phoneCode: '976', label: 'Country:Mongolia' },
  { isoCode: 'MS', phoneCode: '1664', label: 'Country:Montserrat', totalLength: 11 },
  { isoCode: 'MM', phoneCode: '95', label: 'Country:Myanmar' },
  { isoCode: 'NA', phoneCode: '264', label: 'Country:Namibia' },
  { isoCode: 'NR', phoneCode: '674', label: 'Country:Nauru' },
  { isoCode: 'NP', phoneCode: '977', label: 'Country:Nepal' },
  { isoCode: 'NE', phoneCode: '227', label: 'Country:Niger', totalLength: 11 },
  { isoCode: 'NG', phoneCode: '234', label: 'Country:Nigeria' },
  { isoCode: 'NL', phoneCode: '31', label: 'Country:Netherlands', totalLength: 11 },
  { isoCode: 'NI', phoneCode: '505', label: 'Country:Nicaragua', totalLength: 11 },
  { isoCode: 'NU', phoneCode: '683', label: 'Country:Niue' },
  { isoCode: 'NZ', phoneCode: '64', label: 'Country:New Zealand', totalLength: 10 },
  { isoCode: 'NC', phoneCode: '687', label: 'Country:New Caledonia' },
  { isoCode: 'NO', phoneCode: '47', label: 'Country:Norway', totalLength: 10 },
  { isoCode: 'AE', phoneCode: '971', label: 'Country:United Arab Emirates' },
  { isoCode: 'OM', phoneCode: '968', label: 'Country:Oman' },
  { isoCode: 'PK', phoneCode: '92', label: 'Country:Pakistan' },
  { isoCode: 'PW', phoneCode: '680', label: 'Country:Palau' },
  { isoCode: 'PS', phoneCode: '970', label: 'Country:Palestine' },
  { isoCode: 'PA', phoneCode: '507', label: 'Country:Panama' },
  { isoCode: 'PG', phoneCode: '675', label: 'Country:Papua New Guinea' },
  { isoCode: 'PY', phoneCode: '595', label: 'Country:Paraguay' },
  { isoCode: 'PE', phoneCode: '51', label: 'Country:Peru' },
  { isoCode: 'PN', phoneCode: '649', label: 'Country:Pitcairn', minLength: 4, maxLength: 5, totalLength: 9 },
  { isoCode: 'PL', phoneCode: '48', label: 'Country:Poland' },
  { isoCode: 'PT', phoneCode: '351', label: 'Country:Portugal' },
  { isoCode: 'PR', phoneCode: '1', label: 'Country:Puerto Rico', areaCodes: ['787', '939'], totalLength: 11 },
  { isoCode: 'RE', phoneCode: '262262', label: 'Country:Reunion', totalLength: 12 },
  { isoCode: 'RU', phoneCode: '7', label: 'Country:Russia', totalLength: 11, nextDigitPattern: ['3', '4', '5', '8', '9'] },
  { isoCode: 'RW', phoneCode: '250', label: 'Country:Rwanda', totalLength: 12 },
  { isoCode: 'RO', phoneCode: '40', label: 'Country:Romania', totalLength: 11 },
  { isoCode: 'WS', phoneCode: '685', label: 'Country:Samoa' },
  { isoCode: 'SM', phoneCode: '378', label: 'Country:San Marino' },
  { isoCode: 'ST', phoneCode: '239', label: 'Country:Sao Tome and Principe' },
  { isoCode: 'SA', phoneCode: '966', label: 'Country:Saudi Arabia' },
  { isoCode: 'SZ', phoneCode: '268', label: 'Country:Swaziland' },
  { isoCode: 'SH', phoneCode: '290', label: 'Country:Saint Helena' },
  { isoCode: 'MP', phoneCode: '1670', label: 'Country:Northern Mariana Islands', totalLength: 11 },
  { isoCode: 'BL', phoneCode: '590690', label: 'Country:Saint Barthelemy', totalLength: 12 },
  { isoCode: 'KN', phoneCode: '1869', label: 'Country:Saint Kitts and Nevis', totalLength: 11 },
  { isoCode: 'LC', phoneCode: '1758', label: 'Country:Saint Lucia', totalLength: 11 },
  { isoCode: 'MF', phoneCode: '590690', label: 'Country:Saint Martin', totalLength: 12 },
  { isoCode: 'PM', phoneCode: '508', label: 'Country:Saint Pierre and Miquelon' },
  { isoCode: 'VC', phoneCode: '1784', label: 'Country:Saint Vincent and the Grenadines', totalLength: 11 },
  { isoCode: 'SN', phoneCode: '221', label: 'Country:Senegal', totalLength: 12 },
  { isoCode: 'RS', phoneCode: '381', label: 'Country:Serbia' },
  { isoCode: 'SC', phoneCode: '248', label: 'Country:Seychelles' },
  { isoCode: 'SG', phoneCode: '65', label: 'Country:Singapore' },
  { isoCode: 'SX', phoneCode: '1721', label: 'Country:Sint Maarten', totalLength: 11 },
  { isoCode: 'SK', phoneCode: '421', label: 'Country:Slovakia' },
  { isoCode: 'SI', phoneCode: '386', label: 'Country:Slovenia', totalLength: 11 },
  { isoCode: 'SB', phoneCode: '685', label: 'Country:Solomon Islands' },
  { isoCode: 'SO', phoneCode: '252', label: 'Country:Somalia' },
  { isoCode: 'SD', phoneCode: '249', label: 'Country:Sudan', totalLength: 12 },
  { isoCode: 'SR', phoneCode: '597', label: 'Country:Suriname' },
  { isoCode: 'US', phoneCode: '1', label: 'Country:USA', totalLength: 11 },
  { isoCode: 'SL', phoneCode: '232', label: 'Country:Sierra Leone', totalLength: 11 },
  { isoCode: 'TJ', phoneCode: '992', label: 'Country:Tajikistan', totalLength: 12 },
  { isoCode: 'TH', phoneCode: '66', label: 'Country:Thailand' },
  { isoCode: 'TW', phoneCode: '886', label: 'Country:Taiwan' },
  { isoCode: 'TZ', phoneCode: '255', label: 'Country:Tanzania', totalLength: 12 },
  { isoCode: 'TC', phoneCode: '1649', label: 'Country:Turks and Caicos Islands', totalLength: 11 },
  { isoCode: 'TG', phoneCode: '228', label: 'Country:Togo', totalLength: 11 },
  { isoCode: 'TK', phoneCode: '690', label: 'Country:Tokelau' },
  { isoCode: 'TO', phoneCode: '676', label: 'Country:Tonga' },
  { isoCode: 'TT', phoneCode: '1868', label: 'Country:Trinidad and Tobago', totalLength: 11 },
  { isoCode: 'TV', phoneCode: '688', label: 'Country:Tuvalu' },
  { isoCode: 'TN', phoneCode: '216', label: 'Country:Tunisia', totalLength: 11 },
  { isoCode: 'TM', phoneCode: '993', label: 'Country:Turkmenistan', totalLength: 11 },
  { isoCode: 'TR', phoneCode: '90', label: 'Country:Turkey', totalLength: 12 },
  { isoCode: 'UG', phoneCode: '256', label: 'Country:Uganda', totalLength: 12 },
  { isoCode: 'UZ', phoneCode: '998', label: 'Country:Uzbekistan', totalLength: 12 },
  { isoCode: 'UY', phoneCode: '598', label: 'Country:Uruguay' },
  { isoCode: 'FO', phoneCode: '298', label: 'Country:Faroe Islands' },
  { isoCode: 'FJ', phoneCode: '679', label: 'Country:Fiji' },
  { isoCode: 'PH', phoneCode: '63', label: 'Country:Philippines' },
  { isoCode: 'FI', phoneCode: '358', label: 'Country:Finland' },
  { isoCode: 'FK', phoneCode: '500', label: 'Country:Falkland Islands' },
  { isoCode: 'FR', phoneCode: '33', label: 'Country:France', totalLength: 11 },
  { isoCode: 'GF', phoneCode: '594', label: 'Country:French Guiana' },
  { isoCode: 'PF', phoneCode: '689', label: 'Country:French Polynesia' },
  { isoCode: 'TF', phoneCode: '262269', label: 'Country:French Southern Territories', totalLength: 12 },
  { isoCode: 'HR', phoneCode: '385', label: 'Country:Croatia' },
  { isoCode: 'CF', phoneCode: '236', label: 'Country:Central African Republic', totalLength: 11 },
  { isoCode: 'TD', phoneCode: '235', label: 'Country:Chad', totalLength: 11 },
  { isoCode: 'ME', phoneCode: '382', label: 'Country:Montenegro' },
  { isoCode: 'CZ', phoneCode: '420', label: 'Country:Czech Republic' },
  { isoCode: 'CL', phoneCode: '56', label: 'Country:Chile' },
  { isoCode: 'CH', phoneCode: '41', label: 'Country:Switzerland' },
  { isoCode: 'SE', phoneCode: '46', label: 'Country:Sweden' },
  { isoCode: 'SJ', phoneCode: '47790', label: 'Country:Svalbard and Jan Mayen' },
  { isoCode: 'LK', phoneCode: '94', label: 'Country:Sri Lanka', totalLength: 11 },
  { isoCode: 'EC', phoneCode: '593', label: 'Country:Ecuador', totalLength: 11 },
  { isoCode: 'GQ', phoneCode: '240', label: 'Country:Equatorial Guinea', totalLength: 12 },
  { isoCode: 'ER', phoneCode: '291', label: 'Country:Eritrea' },
  { isoCode: 'EE', phoneCode: '372', label: 'Country:Estonia' },
  { isoCode: 'ET', phoneCode: '251', label: 'Country:Ethiopia', totalLength: 12 },
  { isoCode: 'ZA', phoneCode: '27', label: 'Country:South Africa', totalLength: 11 },
  { isoCode: 'GS', phoneCode: '500', label: 'Country:South Georgia and the South Sandwich Islands' },
  { isoCode: 'SS', phoneCode: '211', label: 'Country:South Sudan' },
  { isoCode: 'JM', phoneCode: '1876', label: 'Country:Jamaica', totalLength: 11 },
  { isoCode: 'JP', phoneCode: '81', label: 'Country:Japan' },
  { isoCode: 'JO', phoneCode: '962', label: 'Country:Jordan' },
  { isoCode: 'SY', phoneCode: '963', label: 'Country:Syria' },
]

// Мінімальна кількість цифр для телефонного номера
export const PHONE_MIN_DIGITS = 7
